<app-loader [isLoading]="isLoading"></app-loader>
<div class="wishlist-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="wishlist-text">Edit wishlist Name</span>
    <div class="img-container" mat-dialog-close>
      <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
    </div>
  </div>
  <form (ngSubmit)="editWishlist()">
    <div class="d-flex flex-column mt-5">
      <label class="select-wishlist mb-1">Enter New Name</label>
      <input type="text" class="search-input dp-input-control" (keydown)="restrictWishlistNameInput($event)"
        placeholder="Enter a name for the wishlist" [formControl]="wishlistName" />
    </div>
    <div class="d-flex justify-content-center mt-5">
      <button class="dp-primary-btn wishlist-btn ms-3" type="submit">
        Save Changes
      </button>
    </div>
  </form>
</div>